<template>
  <div>
    <router-view name="templates" :key="`${$route.fullPath}${counter}`">
      <template v-slot:navigation>
        <UserSubmenu>
          <router-link class="button" :to="{ name: 'template.create' }" @click.native="incrementKeyCount" exact>
            <span class="icon is-small">
              <i class="mdi mdi-plus-circle-outline"></i>
            </span>
            <span>Новый шаблон</span>
          </router-link>
        </UserSubmenu>
      </template>
    </router-view>
  </div>
</template>

<script>
export default {
  components: {
    UserSubmenu: () => import(/* webpackChunkName: "UserSubmenu" */ '@/components/user/UserSubmenu')
  },
  metaInfo() {
    return {
      title: 'Шаблоны'
    };
  },
  data() {
    return {
      counter: 0
    };
  },
  methods: {
    incrementKeyCount() {
      this.counter++;
    }
  }
};
</script>

<style lang="scss"></style>
